<template>
    <div class="login-page">
        <div class="form">
            <div class="form-header">
                <h2>Nombre de usuario</h2>
            </div>
            <form class="login-form needs-validation" novalidate action @submit.prevent="login">
                <label for="documento">Tipo de documento</label>
                <div class="row grup">
                    <div class="col-10 position-relative">
                        <div class="select-box">
                            <select class=" form-select" required v-model="TipoDocumento">
                                <option selected disabled value="">Seleccione</option>
                                <option>
                                    <input class="form-control" id="CC" value="CC" required />
                                    <label class="form-label" for="CC">CC</label>
                                </option>
                                <option>
                                    <input class="form-control" id="CE" value="CE" required />
                                    <label class="form-label" for="CE">CE</label>

                                </option>
                                <option>
                                    <input class="form-control" id="TI" value="TI" required />
                                    <label class="form-label" for="TI">TI</label>

                                </option>
                                <option>
                                    <input class="form-control" id="PAP" value="PAP" required />
                                    <label class="form-label" for="PAP ">PAP</label>
                                </option>
                            </select>
                            <!-- </div>
                                </div> -->
                            <div class="options-container">

                            </div>
                            <div class="invalid-tooltip">
                                Seleccione un tipo de documento
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <Popper
                            content="Seleccione el tipo de documento con el cual desea realizar la autenticación para la presentación del examen"
                            id="popper" placement="right">
                            <img class="icon-ayuda" src="../../assets/ico-pregunta@2x.png" alt="">
                        </Popper>
                    </div>
                </div>

                <label for="fecha-expedicion">Fecha de expedición</label>
                <div class="ayuda row grup ">
                    <div class="col-10 position-relative">
                        <div class="fecha ">
                            <v-date-picker class="inline-block h-full" v-model="FechaDocumento" color="red ">
                                <template v-slot="{ inputValue, togglePopover }">
                                    <div class="positioCalendar">
                                        <input id="calendar" :value="inputValue" @keyup.enter="login"
                                            placeholder="dd/mm/aaaa" required class="input-fecha form-control" />
                                        <a @click="togglePopover()" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                class="w-4 h-4 fill-current">
                                                <path
                                                    d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z">
                                                </path>
                                            </svg>
                                        </a>
                                        <!-- <div class="valid-tooltip">
                                            
                                        </div>  -->
                                        <div class="invalid-tooltip">
                                            Seleccione una fecha de expedición
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </div>
                        <div>
                            <!-- <input type="date" style="-webkit-calendar-picker-indicator{display:none, -webkit-appearance: none}"> -->
                        </div>
                    </div>
                    <div class="col-2">
                        <Popper
                            content="Ingrese la fecha de expedición del documento al que corresponde el Número de identificación"
                            id="popper" placement="right">
                            <img class="icon-ayuda" src="../../assets/ico-pregunta@2x.png" alt="">
                        </Popper>
                    </div>
                </div>

                <label for="identificacion">Número de identificación</label>
                <div class="row grup">
                    <div class="col-10 position-relative">
                        <input class="form-control" v-model="Identificacion" @keyup.enter="login" type=""
                            placeholder="Ej: 10292837465" required pattern="[0-9]+" maxlength="10" />
                        <!-- <div class="valid-tooltip">
                            
                        </div> -->
                        <div class="invalid-tooltip">
                            Ingrese un número de identificación
                        </div>
                    </div>
                    <div class="col-2">
                        <!-- <input name="ctl00$content$tbFiltro" type="text" id="content_tbFiltro" class="form-control" data-toggle="tooltip" title="" data-original-title="En esta caja de texto, el ciudadano define el criterio de búsqueda que corresponde a las palabras por las cuales quiere filtrar la información de la rejilla que se muestran en los títulos de la misma rejilla."> -->
                        <Popper
                            content="Ingrese el número de identificación correspondiente al tipo de documento que ha seleccionado."
                            id="popper" placement="right">
                            <img class="icon-ayuda" src="../../assets/ico-pregunta@2x.png" alt="">
                        </Popper>
                    </div>
                </div>
                <div class="g-recaptcha" >
                    <vue-recaptcha 
                    ref="recaptcha" 
                    sitekey="6Le5GH0jAAAAAOmCdxKnuu2UHWTjZ1FvsZsa_nRW" 
                    @verify="onCaptchaVerified">
                </vue-recaptcha>
                    
                </div>

                <button v-if="Identificacion === '' || FechaDocumento === '' || TipoDocumento === '' "
                    class="ingresar btn btn-primary"  type="submit" :disabled="loading">
                    INGRESAR
                </button>
                <button v-else class="ingresar btn btn-primary" type="submit" data-bs-toggle="modal"
                    data-bs-target="#exampleModal"  @click="getCurrentDate" :disabled="loading">
                    INGRESAR
                </button>
            </form>
        </div>
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ titulo }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        {{ modalBody }}
                    </div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" >Close</button> -->
                        <a type="button" v-bind:href="entrar" v-on:click="redireccionUsuario"
                            v-if="titulo === 'Usuario correcto' || titulo === 'Usuario incorrecto' "
                            class="ingresar btn btn-primary">{{
                            txtBoton
                            }}</a>
                        <div class="loadingio-spinner-spinner-ob2tgisa1fp" v-if="titulo === 'Cargando'">
                            <div class="ldio-6opw4s795s7">
                                <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                                <div></div><div></div><div></div><div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script src="@/components/LoginComponent/LoginComponent">
</script>



<style>
@import "./LoginComponent.css";
</style>